
export const SET_CART = "SET_CART";
export const CLEAR_CART = "CLEAR_CART";
export const MODIFY_CART = "MODIFY_CART";
export const SET_COUPONS = "SET_COUPONS";
export const UPDATE_DISCARDED_CART = "UPDATE_DISCARDED_CART";
export const SOFT_UPDATE_CART = "SOFT_UPDATE_CART";